import {
    Box,
    Typography,
    Select,
    MenuItem,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip,
    Chip,
    Button,
} from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { useMutation, useQuery } from "react-query";
import moment from "moment";
import { useContext, useState } from "react";
import { getDashboardEmployeeTimeSheet, getDashboardEmployeeTimeSheetexport } from "api/services/organization";
import { StyledTaskBox } from "./styles";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useNavigate } from "react-router-dom";
import useQueryParams from "hooks/useQueryParams";
import { maximize, animatedNav } from "assets";
import { getTaskPreferences } from "api/services/preferencess";
import { UserProfileContext } from "context/UserProfile";
import SearchContainer from "components/SearchContainer";
import { useDebounce } from "hooks/useDebounce";
import excelIcon from "./../../../assets/images/128px-Microsoft_Office_Excel_(2019–2025).svg.png";
import { snack } from "components/toast";
import { handleError } from "utils/handleError";
import { getCurrentFormattedDateTime } from "utils";
import { useTheme, useMediaQuery } from "@mui/material";

const msToHM = (ms: number) => {
    if (!ms) return "--";
    const h = Math.floor(ms / 3600000);
    const m = Math.floor((ms % 3600000) / 60000);
    return `${h}h:${m}m`;
};

const getDaysInMonth = (month: string) => {
    const start = moment(month, "YYYY-MM").startOf("month");
    return Array.from({ length: start.daysInMonth() }, (_, i) =>
        start.clone().add(i, "day")
    ).reverse();
};



export default function TimesheetFiledVsNotFiled() {
    const [isHovered, setIsHovered] = useState(false);
    const [preferneces, setPreferences] = useState<any>({ logHour: false });
    const navigate = useNavigate();
    const { queryParams } = useQueryParams();
    const { data: uData } = useContext(UserProfileContext);
    const dashboardType = queryParams.type || "user";
    const [search, setSearch] = useState("");
    const debouncedSearch = useDebounce(search, 500);
    const [viewType] = useState("monthly");
    const [month, setMonth] = useState(moment().format("YYYY-MM"));
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const isTablet = useMediaQuery(theme.breakpoints.down("md"));
    const BASE_COL_WIDTH = isMobile ? 50 : isTablet ? 60 : 70;
    const STICKY_LEFT_WIDTH = isMobile ? 110 : isTablet ? 140 : 200;
    const STICKY_RIGHT_WIDTH = isMobile ? 90 : isTablet ? 120 : 160;

    const { data, isLoading } = useQuery(
        ["dashboard-employee-timesheet", month, debouncedSearch],
        () => getDashboardEmployeeTimeSheet({ month, dashboardType, search: debouncedSearch }),
        {
            select: (res) => res.data,
        }
    );
    const { mutate, isLoading: isExporting } = useMutation(getDashboardEmployeeTimeSheetexport, {
        onSuccess: (res: any) => {
            const arr = new Uint8Array(res.data?.data);
            const blob = new Blob([arr], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const file = window.URL.createObjectURL(blob);
            let link = document.createElement("a");
            const formattedDateTime = getCurrentFormattedDateTime();
            link.href = file;
            link.download = `ATOM - ${month} - Timesheet Filled vs Not Filled ${formattedDateTime}.xlsx`;
            link.click();
            snack.success("Report Exported to Excel");
        },
        onError: (err: any) => {
            snack.error(handleError(err));
        },
    });

    const { isLoading: queryLoading } = useQuery(["approvals-preferenecs", uData?.id], getTaskPreferences, {
        onSuccess: (res: any) => {
            if (res?.data?.approvals) {
                setPreferences(res?.data?.approvals);
            }
        }
    })

    const today = moment().startOf("day");

    const days = getDaysInMonth(month).filter((d) => {
        if (moment(month, "YYYY-MM").isSame(today, "month")) {
            return !d.isAfter(today);
        }
        return true;
    });

    const dataMap = new Map<string, any>();
    const rows = data ?? [];

    rows.forEach((row) => {
        dataMap.set(`${row.userId}_${row.logDate}`, row);
    });


    const usersMap: any = {};
    (data || []).forEach((row) => {
        if (!usersMap[row.userId]) {
            usersMap[row.userId] = {
                userId: row.userId,
                name: row.fullName,
                logs: {},
                total: 0,
                attendance: {
                    present: 0,
                    absent: 0,
                    leave: 0,
                    holiday: 0,
                    notMarked: 0,
                }
            };
        }
        usersMap[row.userId].logs[row.logDate] = { totalLogHours: row.totalLoggedHours, pendingHours: row.pendingHours, approvedHours: row.approvedHours, rejectedHours: row.rejectedHours, taskLogHours: row.taskLogHours, generalLogHours: row.generalLogHours };
        usersMap[row.userId].total += row.totalLoggedHours;
        const type = row.attendanceType;

        if (type === "Present") usersMap[row.userId].attendance.present++;
        else if (type === "Absent") usersMap[row.userId].attendance.absent++;
        else if (type === "Leave") usersMap[row.userId].attendance.leave++;
        else if (type === "Holiday") usersMap[row.userId].attendance.holiday++;
        else usersMap[row.userId].attendance.notMarked++;
    });
    const handleDayClick = (userId: number, date: string) => {
        navigate("/settings/profile?tab=TimeSheet", {
            state: {
                userId,
                date,
                month: moment(date).format("MM-YYYY"),
            },
        });
    };
    const handleClick = () => {
        navigate(
            `/dashboard/employee-time-sheet?type=${dashboardType}&month=${month}`
        );
    };


    const handlePrevMonth = () =>
        setMonth(moment(month).subtract(1, "month").format("YYYY-MM"));

    const handleNextMonth = () =>
        setMonth(moment(month).add(1, "month").format("YYYY-MM"));

    const getAttendanceUI = (rowData: any) => {
        const attendance = {
            type: rowData?.attendanceType,
            checkin_time: rowData?.checkIn,
        }; // from backend

        if (!attendance) {
            return { label: "NM", color: "#8f96a4" }; // Not Marked
        }

        if (
            attendance.type === "Present" ||
            (attendance.type === "Holiday" && attendance.checkin_time)
        ) {
            return { label: "P", color: "#13B26B" };
        }

        if (attendance.type === "Absent") {
            return { label: "A", color: "#EF4444" };
        }

        if (attendance.type === "Leave") {
            return { label: "L", color: "#8B5CF6" };
        }

        if (attendance.type === "Holiday") {
            return { label: "H", color: "#FFD700" };
        }

        return { label: "NM", color: "#8f96a4" };
    };

    const handleExport = () => {
        mutate({ month, dashboardType });
    };

    return (

        <StyledTaskBox>
            <header
                style={{
                    backgroundColor: "#fff",
                    borderRadius: "8px",
                    display: "flex",
                    flexDirection: isMobile ? "column" : "row",
                    justifyContent: "space-between",
                    alignItems: isMobile ? "flex-start" : "center",
                    gap: "10px",
                    padding: "10px",
                    position: "relative",
                }}
            >
                <Typography variant="h6" color={"black"}>
                    Attendance vs Timesheet Submission
                </Typography>

                <Box
                    display="flex"
                    flexWrap="wrap"
                    gap={1}
                    width={isMobile ? "100%" : "auto"}
                    justifyContent={isMobile ? "flex-start" : "flex-end"}
                    marginRight={"30px"}
                >
                    {dashboardType === "admin" && (
                        <Box
                            sx={{
                                width: {
                                    xs: "100%",   // mobile full width
                                    sm: "250px",
                                    md: "300px",
                                },
                                maxWidth: "100%",
                                overflow: "hidden", // prevents overflow breaking
                            }}
                        >
                            <SearchContainer
                                value={search}
                                onChange={setSearch}
                                placeHolder="Search by User Name"
                                minWidth="0px"   // 🔥 override here
                                maxWidth="100%"  // 🔥 override here
                            />
                        </Box>
                    )}

                    <Select
                        size="small"
                        value={month}
                        onChange={(e) => setMonth(e.target.value)}
                        sx={{
                            width: isMobile ? "80%" : 150,
                        }}
                    >
                        {Array.from({ length: 12 }).map((_, i) => {
                            const m = moment().subtract(i, "month").format("YYYY-MM");
                            return (
                                <MenuItem key={m} value={m}>
                                    {moment(m).format("MMM YYYY")}
                                </MenuItem>
                            );
                        })}
                    </Select>

                    {dashboardType === "admin" && (
                        <Button sx={{ minWidth: "auto" }}>
                            <Tooltip title={isExporting ? "Exporting..." : "Export"}>
                                <img
                                    src={excelIcon}
                                    alt="Export"
                                    style={{
                                        width: 28,
                                        height: 28,
                                        opacity: isExporting ? 0.5 : 1,
                                    }}
                                    onClick={handleExport}
                                />
                            </Tooltip>
                        </Button>
                    )}
                </Box>
            </header>
            <main style={{ padding: 0 }}>
                <Box p={2} bgcolor="#fff" borderRadius={2}>
                    {isLoading ? (
                        <Typography align="center">Loading...</Typography>
                    ) : (
                        <TableContainer
                            sx={{
                                maxWidth: "100%",
                                overflowX: "auto",
                            }}
                        >
                            <Box
                                sx={{
                                    minWidth: "max-content",
                                }}
                            >
                                <Table size="small" sx={{
                                    paddingLeft: `${STICKY_LEFT_WIDTH}px`,
                                    paddingRight: `${STICKY_RIGHT_WIDTH}px`,
                                }}>

                                    <TableHead>
                                        <TableRow>
                                            <TableCell
                                                sx={{
                                                    minWidth: STICKY_LEFT_WIDTH,
                                                    maxWidth: STICKY_LEFT_WIDTH,
                                                    width: STICKY_LEFT_WIDTH,
                                                    position: "sticky",
                                                    left: 0,
                                                    zIndex: 3,
                                                    backgroundColor: "#fff",
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    fontWeight: 600
                                                }}
                                            >
                                                User Name
                                            </TableCell>
                                            {/* Date columns → 2x */}
                                            {days.map((d) => (
                                                <TableCell
                                                    key={d.format("YYYY-MM-DD")}
                                                    align="center"
                                                    sx={{
                                                        minWidth: isMobile ? 90 : 160,
                                                        whiteSpace: "nowrap",
                                                        fontWeight: 600

                                                    }}
                                                >
                                                    {d.format("DD MMM")}
                                                </TableCell>
                                            ))}

                                            <TableCell
                                                sx={{
                                                    minWidth: STICKY_RIGHT_WIDTH,
                                                    maxWidth: STICKY_RIGHT_WIDTH,
                                                    width: STICKY_RIGHT_WIDTH,
                                                    position: isMobile ? "relative" : "sticky",
                                                    right: 0,
                                                    zIndex: 3,
                                                    backgroundColor: "#fff",
                                                    whiteSpace: "nowrap",
                                                    fontWeight: 600
                                                }}
                                            >
                                                Month Total
                                            </TableCell>

                                        </TableRow>
                                    </TableHead>


                                    <TableBody>
                                        {Object.values(usersMap)
                                            .sort((a: any, b: any) =>
                                                a.name?.toLowerCase().localeCompare(b.name?.toLowerCase())
                                            )
                                            .map((user: any, idx) => (

                                                <TableRow key={idx}>
                                                    <TableCell
                                                        sx={{
                                                            position: "sticky",
                                                            left: 0,
                                                            backgroundColor: "#fff",
                                                            zIndex: 2,
                                                            whiteSpace: "nowrap",
                                                        }}
                                                    >
                                                        {user.name}
                                                    </TableCell>


                                                    {days.map((d) => {
                                                        const dateStr = d.format("YYYY-MM-DD");
                                                        const isFutureDate = d.isAfter(today);

                                                        const rowData = dataMap.get(`${user.userId}_${dateStr}`);
                                                        const dateKey = d.format("YYYY-MM-DD");
                                                        const STANDARD_WORKING_HOURS = data?.[0]?.standardWorkingHours ?? 8 * 60 * 60 * 1000;
                                                        const log = user.logs[dateKey] || {};
                                                        const logged = log.totalLogHours || 0;
                                                        const pendingHours = log.pendingHours || 0;
                                                        const approvedHours = log.approvedHours || 0;
                                                        const rejectedHours = log.rejectedHours || 0;
                                                        const taskLogHours = log.taskLogHours || 0;
                                                        const generalLogHours = log.generalLogHours || 0;
                                                        return (
                                                            <TableCell
                                                                key={dateStr}
                                                                align="center"
                                                                sx={{ minWidth: 160 }}
                                                            >
                                                                {isFutureDate
                                                                    ? "-"
                                                                    : logged > 0 ? (
                                                                        <Tooltip
                                                                            title={<>
                                                                                <Box sx={{ backgroundColor: "#fff" }} p={1} borderRadius={1} display="flex" flexDirection="column" alignItems="center" gap={0.5} boxShadow={3}>
                                                                                    <Typography color={"#000"} variant="h6">{msToHM(logged)}</Typography>
                                                                                    <Box display={"flex"} flexDirection={"row"} width={isMobile ? "200px" : preferneces?.logHour ? "300px" : "150px"}>
                                                                                        <Box width={preferneces?.logHour ? "50%" : "100%"} color={"#000000"} marginLeft={"8px"}>
                                                                                            <Typography display={"flex"}>
                                                                                                Task : {msToHM(taskLogHours)}
                                                                                            </Typography>
                                                                                            <Typography display={"flex"}>
                                                                                                General : {msToHM(generalLogHours)}
                                                                                            </Typography>
                                                                                        </Box>
                                                                                        {preferneces?.logHour && (<>
                                                                                            <hr />
                                                                                            <Box width={"50%"} marginLeft={"8px"}>
                                                                                                <Typography color={"#F24A00"} display={"flex"}>
                                                                                                    Pending : {msToHM(pendingHours)}
                                                                                                </Typography>
                                                                                                <Typography color={"#11A500"} display={"flex"}>
                                                                                                    Approved : {msToHM(approvedHours)}
                                                                                                </Typography>
                                                                                                <Typography color={"#D4110B"} display={"flex"}>
                                                                                                    Rejected : {msToHM(rejectedHours)}
                                                                                                </ Typography>
                                                                                            </Box></>)}
                                                                                    </Box>
                                                                                </Box>
                                                                            </>}
                                                                            componentsProps={{
                                                                                tooltip: {
                                                                                    sx: {
                                                                                        bgcolor: 'transparent',
                                                                                        padding: 0,
                                                                                        boxShadow: 'none',
                                                                                    }
                                                                                }
                                                                            }}
                                                                        >
                                                                            <Box
                                                                                display="flex"
                                                                                alignItems="center"
                                                                                justifyContent="center"
                                                                                gap={0.5}
                                                                                onClick={() =>
                                                                                    handleDayClick(user.userId, dateStr)
                                                                                }
                                                                            >

                                                                                {/* ✅ NEW: ATTENDANCE BOX */}
                                                                                {(() => {
                                                                                    const attendance = {
                                                                                        type: rowData?.attendanceType,
                                                                                        checkin_time: rowData?.checkIn,
                                                                                    };

                                                                                    let label = "NM";
                                                                                    let color = "#8f96a4";

                                                                                    if (attendance) {
                                                                                        if (
                                                                                            attendance.type === "Present" ||
                                                                                            (attendance.type === "Holiday" && attendance.checkin_time)
                                                                                        ) {
                                                                                            label = "P";
                                                                                            color = "#13B26B";
                                                                                        } else if (attendance.type === "Absent") {
                                                                                            label = "A";
                                                                                            color = "#EF4444";
                                                                                        } else if (attendance.type === "Leave") {
                                                                                            label = "L";
                                                                                            color = "#8B5CF6";
                                                                                        } else if (attendance.type === "Holiday") {
                                                                                            label = "H";
                                                                                            color = "#FFD700";
                                                                                        }
                                                                                    }

                                                                                    return (
                                                                                        <Box
                                                                                            sx={{
                                                                                                ml: 0.5,
                                                                                                fontSize: "10px",
                                                                                                fontWeight: 600,
                                                                                                backgroundColor: color,
                                                                                                color: "#fff",
                                                                                                borderRadius: "4px",
                                                                                                px: "4px",
                                                                                                py: "1px",
                                                                                                minWidth: "20px",
                                                                                                textAlign: "center",
                                                                                            }}
                                                                                        >
                                                                                            {label}
                                                                                        </Box>
                                                                                    );
                                                                                })()}
                                                                                <Typography variant="caption">
                                                                                    {msToHM(logged)}
                                                                                </Typography>
                                                                                <CheckCircleIcon
                                                                                    fontSize="small"
                                                                                    sx={{
                                                                                        color:
                                                                                            logged > STANDARD_WORKING_HOURS
                                                                                                ? "#2196F3"
                                                                                                : logged === STANDARD_WORKING_HOURS
                                                                                                    ? "success.main"
                                                                                                    : "#FF9800",
                                                                                    }}
                                                                                />

                                                                                

                                                                                
                                                                            </Box>
                                                                        </Tooltip>
                                                                    ) : (
                                                                        <Box
                                                                            display="flex"
                                                                            alignItems="center"
                                                                            justifyContent="center"
                                                                            gap={0.5}
                                                                        >

                                                                            {(() => {
                                                                                const attendance = {
                                                                                    type: rowData?.attendanceType,
                                                                                    checkin_time: rowData?.checkIn,
                                                                                };

                                                                                let label = "NM";
                                                                                let color = "#8f96a4";

                                                                                if (attendance) {
                                                                                    if (
                                                                                        attendance.type === "Present" ||
                                                                                        (attendance.type === "Holiday" && attendance.checkin_time)
                                                                                    ) {
                                                                                        label = "P";
                                                                                        color = "#13B26B";
                                                                                    } else if (attendance.type === "Absent") {
                                                                                        label = "A";
                                                                                        color = "#EF4444";
                                                                                    } else if (attendance.type === "Leave") {
                                                                                        label = "L";
                                                                                        color = "#8B5CF6";
                                                                                    } else if (attendance.type === "Holiday") {
                                                                                        label = "H";
                                                                                        color = "#FFD700";
                                                                                    }
                                                                                }

                                                                                return (
                                                                                    <Box
                                                                                        sx={{
                                                                                            ml: 0.5,
                                                                                            fontSize: "10px",
                                                                                            fontWeight: 600,
                                                                                            backgroundColor: color,
                                                                                            color: "#fff",
                                                                                            borderRadius: "4px",
                                                                                            px: "4px",
                                                                                            py: "1px",
                                                                                            minWidth: "20px",
                                                                                            textAlign: "center",
                                                                                        }}
                                                                                    >
                                                                                        {label}
                                                                                    </Box>
                                                                                );
                                                                            })()}
                                                                            <CancelIcon
                                                                                fontSize="small"
                                                                                color="error"
                                                                                onClick={() =>
                                                                                    handleDayClick(user.userId, dateStr)
                                                                                }
                                                                            />


                                                                        </Box>
                                                                    )}
                                                            </TableCell>
                                                        );
                                                    })}

                                                    <TableCell
                                                        align="center"
                                                        sx={{
                                                            position: isMobile ? "relative" : "sticky",
                                                            right: -1,
                                                            backgroundColor: "#fff",
                                                            zIndex: 2,
                                                            whiteSpace: "nowrap",
                                                            cursor: "pointer",
                                                        }}
                                                    >
                                                        <Tooltip
                                                            title={
                                                                <Box
                                                                    sx={{
                                                                        backgroundColor: "#fff",
                                                                        color: "#000",
                                                                        p: 1.5,
                                                                        borderRadius: 1,
                                                                        boxShadow: 3,
                                                                        minWidth: 220,
                                                                        cursor: "pointer",
                                                                    }}
                                                                >
                                                                    {/* Total */}
                                                                    <Typography fontWeight={500} mb={1}>
                                                                        Total Timesheet Filled : {msToHM(user.total)}
                                                                    </Typography>

                                                                    {/* Attendance */}
                                                                    <Typography fontWeight="bold" mb={0.5}>
                                                                        Attendance
                                                                    </Typography>

                                                                    <Typography sx={{ color: "#13B26B" }}>
                                                                        Presents -- {user.attendance.present}
                                                                    </Typography>

                                                                    <Typography sx={{ color: "#EF4444" }}>
                                                                        Absents -- {user.attendance.absent}
                                                                    </Typography>

                                                                    <Typography sx={{ color: "#8B5CF6" }}>
                                                                        Leaves -- {user.attendance.leave}
                                                                    </Typography>

                                                                    <Typography sx={{ color: "#FFD700" }}>
                                                                        Holidays -- {user.attendance.holiday}
                                                                    </Typography>

                                                                    <Typography sx={{ color: "#8f96a4" }}>
                                                                        Not marked -- {user.attendance.notMarked}
                                                                    </Typography>
                                                                </Box>
                                                            }
                                                            componentsProps={{
                                                                tooltip: {
                                                                    sx: {
                                                                        bgcolor: "transparent",
                                                                        p: 0,
                                                                        boxShadow: "none",
                                                                    },
                                                                },
                                                            }}
                                                        >
                                                            <Chip
                                                                size="small"
                                                                color={user.total ? "success" : "error"}
                                                                label={msToHM(user.total)}
                                                            />
                                                        </Tooltip>
                                                    </TableCell>

                                                </TableRow>
                                            ))}
                                    </TableBody>
                                </Table>
                            </Box>
                        </TableContainer>
                    )}
                </Box>
            </main>
        </StyledTaskBox>
    );
}
